import { mediaGQLFields } from '../media/media.fields.js';
import { memberGQLFields } from '../network/member.fields.js';
import { networkGQLFields } from '../network/network.fields.js';
import { slateGQLFields } from '../slate/slate.fields.js';
const BASIC_TEMPLATE_FIELDS = {};
const ALL_TEMPLATE_FIELDS = {
    banner: 'basic',
    createdBy: 'basic',
    favicon: 'basic',
    image: 'basic',
    images: 'basic',
    network: 'basic',
    updatedBy: 'basic',
    requiredTemplates: 'basic',
    slate: 'all',
};
export function templateGQLFields(fields) {
    if (fields === 'basic')
        fields = BASIC_TEMPLATE_FIELDS;
    if (fields === 'all')
        fields = ALL_TEMPLATE_FIELDS;
    return `
    id
    name
    description
    slug
    status
    standing
    createdById
    about
    authorName
    authorUrl
    entityType
    imageId
    bannerId
    createdAt
    categories
    comingSoon
    embedIds
    faviconId
    networkId
    updatedAt
    updatedById
    requiredPlan
    entityProperties
    ${fields.banner
        ? `
      banner {
        ${mediaGQLFields(fields.banner)}
      }
    `
        : ``}
    ${fields.createdBy
        ? `
      createdBy {
        ${memberGQLFields(fields.createdBy)}
      }
    `
        : ``}
    ${fields.favicon
        ? `
      favicon {
        ${mediaGQLFields(fields.favicon)}
      }
    `
        : ``}
    ${fields.image
        ? `
      image {
        ${mediaGQLFields(fields.image)}
      }
    `
        : ``}
    ${fields.images
        ? `
      images {
        ${mediaGQLFields(fields.images)}
      }
    `
        : ``}
    ${fields.network
        ? `
      network {
        ${networkGQLFields(fields.network)}
      }
    `
        : ``}
    ${fields.updatedBy
        ? `
      updatedBy {
        ${memberGQLFields(fields.updatedBy)}
      }
    `
        : ``}
    ${fields.requiredTemplates
        ? `
      requiredTemplates {
        ${templateGQLFields(fields.requiredTemplates)}
      }
    `
        : ``}
    ${fields.slate
        ? `
      slate {
        ${slateGQLFields(fields.slate)}
      }
    `
        : ``}
  `;
}
//# sourceMappingURL=template.fields.js.map